import { Action } from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {HardwareFaultLevels} from '../../../models/events';
import * as actions from '../../../store/actions';
import {HardwareFaultLevelActionTypes} from '../../../store/actions';


export interface State extends EntityState<HardwareFaultLevels> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<HardwareFaultLevels> = createEntityAdapter<HardwareFaultLevels>({
  selectId: levelMap => levelMap.LevelCode
});

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(state = initialState, action: actions.HardwareFaultLevelActions): State {
  switch (action.type) {
    case actions.HardwareFaultLevelActionTypes.LoadHardwareFaultLevels:
      return adapter.setAll(action.payload, {...state, Loaded: true, Loading: false});
    case HardwareFaultLevelActionTypes.GetHardwareFaultLevelFails:
      return {...state, Loaded: false, Loading: false};
    default:
      return state;
  }
}
